const WEEKDAYS = [
  "Duminică",
  "Luni",
  "Marți",
  "Miercuri",
  "Joi",
  "Vineri",
  "Sâmbătă",
];

export const getNextWeekdayDate = (weekday, fromDate = new Date()) => {
  const targetDay = WEEKDAYS.indexOf(weekday);

  if (targetDay < 0 || Number.isNaN(fromDate.getTime())) return null;

  const result = new Date(fromDate);
  result.setHours(12, 0, 0, 0);
  let daysUntilTarget = (targetDay - result.getDay() + 7) % 7;
  if (daysUntilTarget === 0) daysUntilTarget = 7;
  result.setDate(result.getDate() + daysUntilTarget);
  return result;
};

export const toLocalIsoDate = (date) => {
  if (!date) return "";
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const formatAppointmentDate = (date) => {
  if (!date) return "";
  return new Intl.DateTimeFormat("ro-RO", {
    day: "numeric",
    month: "long",
    year: "numeric",
  }).format(date);
};
